import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import * as layoutActions from '../../actions/layoutActions';
import * as simulatieDossierActions from '../../actions/simulatieDossierActions';
import mergeDeep from "../../util/mergeDeep";

import * as types from "../../constants/ComponentConstants";
import redirector from "../../util/redirector.js";

import SimulatieDossierForm from "./SimulatieDossierForm";
import SimulatieDossierPageHelper from "./SimulatieDossierPageHelper";

import EasterEggHandler from "../common/EasterEggHandler";
import ConfirmModal from "../common/ConfirmModal";

import * as pageConstants from "../../constants/EasterEggConstants";

import GenerateGuid from "../../util/guid";

class SimulatieDossierPage extends AutoBindComponent {
	constructor(props) {
		super(props);

		this.state = {
			hasUnsavedChanges: false,
			simulatieDossier: null,
			errors: {},
			mapKey: GenerateGuid(),
			center: {
				lat: '',
				lng: ''
			},
			infraModalIsOpen: false,
			addInfraModalIsOpen: false,
			inEditMode: false,
			newCoordinates: {},
			draggable: false,
			disabled: false,
			infraRemoved: false,
			saveWhenInfraRemovedIsOpen: false,
			nieuwbouwModalIsOpen: false,
			addNieuwbouwInfraModalIsOpen: false,
			deleteNieuwbouwInfraModalIsOpen: false,
			addRenovatieToProjectModalIsOpen: false,
			verdwijnendeInfraModalIsOpen: false,
			verdwijnendeInfra: null,
			verdwijnendeInfraPosition: null
		};

		this.pageHelper = new SimulatieDossierPageHelper(this, redirector);

		this.prefillHelper = new EasterEggHandler(this, pageConstants.SIMULATIEDOSSIER);
	}

	componentDidMount() {
		this.setState({
			hasUnsavedChanges: !this.props.isSaved
		});

		this.prefillHelper.bind();
	}
	componentWillUnmount() {
		this.prefillHelper.unbind();
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	componentWillUpdate() {
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.simulatieDossier && nextProps.simulatieDossier.id) {
			const center = (nextProps.simulatieDossier.breedtegraad && nextProps.simulatieDossier.lengtegraad) ? Object.assign({}, { lat: parseFloat(nextProps.simulatieDossier.breedtegraad), lng: parseFloat(nextProps.simulatieDossier.lengtegraad) }) : {};
			this.setState({
				newCoordinates: Object.assign({}, { lat: nextProps.simulatieDossier.breedtegraad, lng: nextProps.simulatieDossier.lengtegraad }),
				simulatieDossier: nextProps.simulatieDossier,
				center: center
			});
		}

		if (nextProps.gemeenten.length && nextProps.postcodes.length) {
			this.prefillHelper.initiateGemeenten(nextProps.gemeenten);
			this.prefillHelper.initiatePostcoden(nextProps.postcodes);
		}

		this.pageHelper.reloadIfRecievedFromNew(nextProps);
	}

	handleOnChange(event, data, i) {
		this.pageHelper.change(event, data, i);
	}

	handleOnChangeRenovatieTable(event, id) {
		this.pageHelper.changeRenovatieTable(event, id);
	}

	handleOnGoToRenovatieInfrastructuurDetail() {
		this.pageHelper.goToRenovatieInfrastructuurDetail();
	}

	handleOnCancelRenovatieInfrastructuurDetail() {
		this.pageHelper.cancelRenovatieInfrastructuurDetail();
	}

	handleOnChangeVerdwijnendeInfrasTable(event, id) {
		this.pageHelper.changeVerdwijnendeInfraTable(event, id, window.parent.scrollY);
	}

	handleOnCancelVerdwijnendeInfras() {
		window.parent.scrollTo(0, this.state.verdwijnendeInfraPosition);
		this.pageHelper.cancelVerdwijnendeInfra();
	}

	handleOnConfirmVerdwijnendeInfras() {
		window.parent.scrollTo(0, this.state.verdwijnendeInfraPosition);
		this.pageHelper.confirmVerdwijnendeInfra();
	}

	handleOnChangeSoortDossier(event) {
		this.pageHelper.changeSoortDossier(event);
	}

	handleOnCloseNieuwbouwModal() {
		this.pageHelper.closeNieuwbouwModal();
	}

	handleOnSave() {
		if (this.state.infraRemoved)
			this.setState({
				saveWhenInfraRemovedIsOpen: true
			});
		else
			this.handleOnSaveConfirmed();
	}

	handleOnSaveConfirmed() {
		this.pageHelper.save();
		this.setState({
			saveWhenInfraRemovedIsOpen: false
		});
	}

	handleOnCancelConfirmSave() {
		this.setState({
			saveWhenInfraRemovedIsOpen: false
		});
	}

	handleOnAddInfrastructuur() {
		this.pageHelper.addNewInfrastructuur();
	}

	handleOnAddNieuwbouwInfrastructuur() {
		this.pageHelper.addNieuwbouwInfrastructuur();
	}

	handleOnDeleteNieuwbouwInfrastructuur(infraId) {
		this.pageHelper.deleteNieuwbouwInfrastructuur(infraId);
	}

	handleOnCancelDeleteNieuwbouwInfrastructuur() {
		this.pageHelper.cancelDeleteNieuwbouwInfra();
	}

	handleOnGoToDeleteNieuwbouwInfrastructuur() {
		this.pageHelper.gotoDeleteNieuwbouwInfra();
	}

	handleOnCancelNieuwbouwInfrastructuur() {
		this.pageHelper.cancelNieuwbouwInfrastructuur();
	}

	handleOnGoToAddNieuwbouwInfrastructuur() {
		this.pageHelper.gotoAddNieuwbouwInfrastructuur(this.state.simulatieDossier.id);
	}

	handleOnSimuleer(event) {
		const savePromise = this.pageHelper.save(event, false);
		savePromise.then(() => this.pageHelper.simuleer());
	}

	handleOnGetGeoCoordinates() {
		this.pageHelper.getGeoCoordinates();
	}

	handleOnGoToInfrastructuurDetail(event) {
		this.props.storeSimulatieDossier(this.state.simulatieDossier);
		this.setState({ hasUnsavedChanges: false }, () => {
			redirector.goTo(`simulatiedossier/infra/${this.state.selectedInfraId}/edit`);
		});
	}
	handleOnCancelEditInfrastructuur() {
		let simulatiedossier = mergeDeep({}, this.state.simulatieDossier);
		simulatiedossier.sportinfrastructurenInDeBuurt.find(x => x.id === this.state.selectedInfraId).deelVanAanvraag = 1;

		return this.setState({
			simulatiedossier,
			infraModalIsOpen: false,
			selectedInfraId: null
		});
	}

	handleOnCancelAddInfrastructuur() {
		return this.setState({
			addInfraModalIsOpen: false
		});
	}

	handleOnGoToAddInfrastructuur() {
		this.pageHelper.addNewInfrastructuurAndGoToEdit(this.state.simulatieDossier.id);
	}

	handleOnEditInfrastructuur(infraId) {
		this.props.storeSimulatieDossier(this.state.simulatieDossier);
		this.setState({ hasUnsavedChanges: false }, () => {
			redirector.goTo(`simulatiedossier/infra/${infraId}/edit`);
		});
	}

	handleOnReplacePoint() {
		this.setState({
			inEditMode: true,
			disabled: true
		});
	}

	handleOnSaveNewPoint() {
		let newSimulatieDossier = Object.assign({}, this.state.simulatieDossier, { breedtegraad: parseFloat(this.state.newCoordinates.lat), lengtegraad: parseFloat(this.state.newCoordinates.lng) });
		this.setState({
			inEditMode: false,
			disabled: false,
			mapKey: GenerateGuid(),
			simulatieDossier: newSimulatieDossier,
			draggable: false
		}, () => this.pageHelper.getInfrastructurenInDeBuurt(newSimulatieDossier.lengtegraad, newSimulatieDossier.breedtegraad));
	}

	handleOnCancelReplace() {
		let originalCoordinates = Object.assign({}, { lat: parseFloat(this.state.simulatieDossier.breedtegraad), lng: parseFloat(this.state.simulatieDossier.lengtegraad) });
		this.setState({
			inEditMode: false,
			disabled: false,
			center: originalCoordinates,
			newCoordinates: originalCoordinates
		});
	}

	handleOnDragEnd(e) {
		const movedMarker = mergeDeep({}, this.state.newCoordinates);

		movedMarker.lat = e.target.getLatLng().lat;
		movedMarker.lng = e.target.getLatLng().lng;

		this.setState({
			newCoordinates: movedMarker
		});
	}

	handleOnClickTooltip(value, i) {
		if (i != -1) {
			const simulatieDossier = this.state.simulatieDossier;

			simulatieDossier.sportinfrastructurenOpKaart[i] = Object.assign(simulatieDossier.sportinfrastructurenOpKaart[i], { tooltip: value });
			this.setState({ simulatieDossier: simulatieDossier });
		} else {
			this.setState({ tooltip: value });
		}
	}

	render() {
		if (!this.pageHelper.isReadyToRender())
			return null;

		const disabled = this.props.disabled || (this.state.simulatieDossier && this.state.simulatieDossier.redenVanStatus == 121450001) || this.state.disabled;
		const disableSimuleer = disabled || (this.state.simulatieDossier && this.state.simulatieDossier.version == 0);
		const soortenInfrastructuur = !(this.state.simulatieDossier.andereInfrastructurenBeschikbaar === true || this.state.simulatieDossier.andereInfrastructurenBeschikbaar === "true") ? this.props.soortenInfrastructuur.filter((x, i) => i > 0) : this.props.soortenInfrastructuur;

		const {
			maxMapFeaturesToLoad,
			osmBaseLayerUrl
		} = this.props;

		const simulatieDossierFormProps = {
			simulatieDossier: this.state.simulatieDossier,
			disabled: disabled,
			disableSimuleer: disableSimuleer,
			errors: this.state.errors,
			validationMessageType: this.state.validationMessageType,
			postcodes: this.props.postcodes,
			gemeenten: this.props.gemeenten,
			soortenInfrastructuur: soortenInfrastructuur,
			soortenInfrastructuurAll: this.props.soortenInfrastructuurAll,
			onChange: this.handleOnChange,
			onChangeRenovatieTable: this.handleOnChangeRenovatieTable,
			onChangeVerdwijnendeInfrasTable: this.handleOnChangeVerdwijnendeInfrasTable,
			onChangeDossierSoort: this.handleOnChangeSoortDossier,
			onEditInfrastructuur: this.handleOnEditInfrastructuur,
			onSave: this.handleOnSave,
			color: types.COLOR_BLUE,
			onAddInfrastructuur: this.handleOnAddInfrastructuur,
			onAddNieuwbouwInfrastructuur: this.handleOnAddNieuwbouwInfrastructuur,
			onDeleteNieuwbouwInfrastructuur: this.handleOnDeleteNieuwbouwInfrastructuur,
			onSimuleer: this.handleOnSimuleer,
			onGetGeoCoordinates: this.handleOnGetGeoCoordinates,
			mapKey: this.state.mapKey,
			center: this.state.center,
			onReplacePoint: this.handleOnReplacePoint,
			saveNewPoint: this.handleOnSaveNewPoint,
			cancelReplace: this.handleOnCancelReplace,
			inEditMode: this.state.inEditMode,
			newCoords: this.state.newCoordinates,
			draggable: this.state.draggable,
			onClickTooltip: this.handleOnClickTooltip,
			maxMapFeaturesToLoad: maxMapFeaturesToLoad,
			osmBaseLayerUrl: osmBaseLayerUrl,
			onMarkerDragEnd: this.handleOnDragEnd
		};
		return (<div>
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.saveWhenInfraRemovedIsOpen}
				mainText="Opgelet: Je hebt één of meerdere sportinfrastructuren van je subsidieaanvraag gewijzigd naar Nee of Reconversie!
					De sportinfrastructuren die je op Reconversie hebt gezet zullen overal verwijderd worden als infrastructuur op wandelafstand.
					Voor alle sportinfrastructuren die je van Ja naar Nee of Reconversie gezet hebt worden alle gerelateerde gegevens ivm minimale eisen en bovenlokaliteit verwijderd.
					Wil je verder gaan?"
				confirmAction={this.handleOnSaveConfirmed}
				confirmText="Ga verder"
				cancelAction={this.handleOnCancelConfirmSave}
				cancelText="Terug" />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.infraModalIsOpen}
				mainText="Om een infrastructuur te kunnen toevoegen aan je dossier moet je volgende formulier verder aanvullen."
				confirmAction={this.handleOnGoToInfrastructuurDetail}
				confirmText="Ga verder"
				cancelAction={this.handleOnCancelEditInfrastructuur}
				cancelText="Terug" />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.addRenovatieToProjectModalIsOpen}
				mainText="Om de renovatie van een infrastructuur te kunnen toevoegen aan je dossier moet je het volgende formulier verder invullen."
				confirmAction={this.handleOnGoToRenovatieInfrastructuurDetail}
				confirmText="Ga verder"
				cancelText="Terug"
				cancelAction={this.handleOnCancelRenovatieInfrastructuurDetail} />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.addNieuwbouwInfraModalIsOpen}
				mainText="Hier mag je enkel een nieuwbouw sportinfrastructuur toevoegen waarvoor je subsidies aanvraagt"
				confirmAction={this.handleOnGoToAddNieuwbouwInfrastructuur}
				confirmText="Ga verder"
				cancelAction={this.handleOnCancelNieuwbouwInfrastructuur}
				cancelText="Terug" />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.deleteNieuwbouwInfraModalIsOpen}
				mainText="Wil je deze toegevoegde sportinfrastructuur terug verwijderen?"
				confirmAction={this.handleOnGoToDeleteNieuwbouwInfrastructuur}
				confirmText="Ga verder"
				cancelAction={this.handleOnCancelDeleteNieuwbouwInfrastructuur}
				cancelText="Terug" />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.addInfraModalIsOpen}
				mainText="Hier mag je enkel een bestaande sportinfrastructuur toevoegen die gerenoveerd wordt in dit project en die niet in onze databank staat."
				confirmAction={this.handleOnGoToAddInfrastructuur}
				confirmText="Ga verder"
				cancelAction={this.handleOnCancelAddInfrastructuur}
				cancelText="Terug" />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.nieuwbouwModalIsOpen}
				mainText="Bevat uw project werkzaamheden aan de randaccommodatie van een bestaande openlucht sportinfrastructuur (vb. bouwen van kleedkamers,
						plaatsen van omheiningen of verlichtingspalen …) dan is dit geen nieuwbouw maar moeten deze werkzaamheden opgegeven worden als
						renovatiewerkzaamheden aan de bestaande openlucht sportinfrastructuur."
				confirmAction={this.handleOnCloseNieuwbouwModal}
				confirmText="OK"
				small />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.verdwijnendeInfraModalIsOpen}
				mainText="Verdwijnt deze infrastructuur door de geplande werkzaamheden ?"
				confirmAction={this.handleOnConfirmVerdwijnendeInfras}
				confirmText="Ja"
				cancelAction={this.handleOnCancelVerdwijnendeInfras}
				cancelText="Nee" />
			<SimulatieDossierForm {...simulatieDossierFormProps} />
		</div >);
	}
}

SimulatieDossierPage.propTypes = {
	disabled: PropTypes.bool,
	loadLayout: PropTypes.func.isRequired,
	postcodes: PropTypes.array.isRequired,
	gemeenten: PropTypes.array.isRequired,
	soortenInfrastructuur: PropTypes.array.isRequired,
	soortenInfrastructuurAll: PropTypes.array.isRequired,
	simulatieDossierId: PropTypes.string,
	infrastructuren: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
	const simulatieDossierId = ownProps.params.simulatieDossierId;
	const simulatieDossierLoaded = state.simulatieDossier.isLoaded;
	const simulatieDossier = state.simulatieDossier.item;
	const infrastructuren = state.infrastructuren;
	const disabled = state.ajaxCounter > 0;
	const isNew = !simulatieDossierId;

	return {
		isNew,
		disabled: disabled,
		simulatieDossierId: simulatieDossierId,
		simulatieDossierLoaded: simulatieDossierLoaded,
		simulatieDossier: mergeDeep({}, simulatieDossier),
		postcodes: convertToLabelValuePair(state.referentie.postcodes),
		gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
		soortenInfrastructuur: state.referentie.soortenInfrastructuur,
		soortenInfrastructuurAll: state.referentie.soortenInfrastructuurAll,
		infrastructuren: infrastructuren,
		isSaved: state.simulatieDossier.isSaved,
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadSimulatieDossierPageLayout, dispatch),
		storeSimulatieDossier: bindActionCreators(simulatieDossierActions.storeSimulatieDossier, dispatch),
		getInfrastructurenInDeBuurt: bindActionCreators(simulatieDossierActions.getInfrastructurenInDeBuurt, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(SimulatieDossierPage));
